// extracted by mini-css-extract-plugin
export default {"login":"GSvknq","logOutText":"VGMdYn"};